/**
 * Les routes poussées du lot Messages (ex-« Mon tutorat ») : celles qu'il fait passer sur le design system.
 *
 * Le lot câble l'onglet (`Tutoring/StudentTutoringScreen.tsx`) et « Tous mes lives »
 * (`live-sessions-list`), route partagée : le pont ne la rend ici que pour un élève dont l'espace
 * est allumé, hors mode parent et hors live ; le parent, le tuteur et l'élève éteint gardent l'écran
 * d'aujourd'hui (`student/tutoring/LiveSessionsListScreen.js`, et son propre pont vers la page du
 * parent).
 *
 * Chaque écran n'est chargé qu'à son premier rendu (`loadedOnRender`).
 */
import { loadedOnRender } from "../loadedOnRender"
import { type StudentSpaceRouteTable } from "../studentSpaceRouteTypes"

/* eslint-disable @typescript-eslint/no-require-imports */
export const tutoringRoutes: StudentSpaceRouteTable<"tutoring"> = {
    "live-sessions-list": loadedOnRender(
        () => require("./StudentLiveSessionsListScreen").StudentLiveSessionsListScreen,
        "StudentLiveSessionsListScreen"
    ),
}
/* eslint-enable @typescript-eslint/no-require-imports */
